/** @format */
export const ENVIRONMENT = "production"; //

// BACKEND SERVER
export const SERVERADDRESS =
  ENVIRONMENT === "production"
    ? "https://bitefoodly-backend-production.up.railway.app/api"
    : "http://localhost:5000/api";
// export const SOCKET_SERVER_ADDRESS = "http://localhost:5000";
// // export const SERVERADDRESS = "/api";

export const SOCKET_SERVER_ADDRESS =
  ENVIRONMENT === "production"
    ? "https://bitefoodly-backend-production.up.railway.app/api"
    : "http://localhost:5000";
// env options
// local or production
// export const ENVIRONMENT2 = "localhost"; // localhost or website

export const BUCKET_BASE_URL =
  "https://pub-208cd20a3b5049a2aa18c7c199b5e57e.r2.dev/";

export const BUCKET_ENDPOINT =
  "https://5aa5d988e1bde0d278ab9f851dccfa85.r2.cloudflarestorage.com";
export const BUCKET_NAME = "bitefoodlyportal";
export const BUCKET_REGION = "auto";
export const BUCKET_ACCESS_KEY_ID = "b66fb2c2c143b626a436ec1caa808431";
export const BUCKET_SECRET_KEY =
  "7b0b2f0e36f69ed390c425f173c334dab1ef8b0d4fa7f193555f059febf91cea";

export const SOCKET_CONNECTED = "SOCKET_CONNECTED";
export const SOCKET_DISCONNECT = "SOCKET_DISCONNECT";

export const GET_NOTIFICATIONS_REQUEST = "GET_NOTIFICATIONS_REQUEST";
export const GET_NOTIFICATIONS_SUCCESS = "GET_NOTIFICATIONS_SUCCESS";
export const GET_NOTIFICATIONS_FAIL = "GET_NOTIFICATIONS_FAIL";

export const NOTIFICATION_RECEIVE_SUCCESS = "NOTIFICATION_RECEIVE_SUCCESS";
export const REMINDER_RECEIVE_SUCCESS = "REMINDER_RECEIVE_SUCCESS";

export const READ_NOTIFICATIONS_REQUEST = "READ_NOTIFICATIONS_REQUEST";
export const READ_NOTIFICATIONS_SUCCESS = "READ_NOTIFICATIONS_SUCCESS";
export const READ_NOTIFICATIONS_FAIL = "READ_NOTIFICATIONS_FAIL";

// USER LOGIN CONST
export const USER_AUTH_REQUEST = "USER_AUTH_REQUEST";
export const USER_AUTH_SUCCESS = "USER_AUTH_SUCCESS";
export const USER_AUTH_FAIL = "USER_AUTH_FAIL";
export const USER_LOGOUT_SUCCESS = "USER_LOGOUT_SUCCESS";
export const USER_LOGOUT_FAIL = "USER_LOGOUT_FAIL";
export const GET_USER_REQUEST = "GET_USER_REQUEST";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_FAIL = "GET_USER_FAIL";
export const USER_CREATE_REQUEST = "USER_CREATE_REQUEST";
export const USER_CREATE_SUCCESS = "USER_CREATE_SUCCESS";
export const USER_CREATE_FAIL = "USER_CREATE_FAIL";
export const ALL_USER_VIEW_REQUEST = "ALL_USER_VIEW_REQUEST";
export const ALL_USER_VIEW_SUCCESS = "ALL_USER_VIEW_SUCCESS";
export const ALL_USER_VIEW_FAIL = "ALL_USER_VIEW_FAIL";
export const ALL_DRIVER_VIEW_REQUEST = "ALL_USER_VIEW_REQUEST";
export const ALL_DRIVER_VIEW_SUCCESS = "ALL_USER_VIEW_SUCCESS";
export const ALL_DRIVER_VIEW_FAIL = "ALL_USER_VIEW_FAIL";
export const USER_BY_ID_SUCCESS = "USER_BY_ID_SUCCESS";
export const CUSTOMERS_BY_ID_SUCCESS = "CUSTOMERS_BY_ID_SUCCESS";
export const ALL_CUSTOMERS_VIEW_REQUEST = "ALL_CUSTOMERS_VIEW_REQUEST";
export const ALL_CUSTOMERS_VIEW_SUCCESS = "ALL_CUSTOMERS_VIEW_SUCCESS";
export const ALL_CUSTOMERS_VIEW_FAIL = "ALL_CUSTOMERS_VIEW_FAIL";
export const ALL_DRIVERS_VIEW_REQUEST = "ALL_DRIVERS_VIEW_REQUEST";
export const ALL_DRIVERS_VIEW_SUCCESS = "ALL_DRIVERS_VIEW_SUCCESS";
export const ALL_DRIVERS_VIEW_FAIL = "ALL_DRIVERS_VIEW_FAIL";
export const USER_UPDATE_REQUEST = "USER_UPDATE_REQUEST";
export const USER_UPDATE_SUCCESS = "USER_UPDATE_SUCCESS";
export const USER_UPDATE_FAIL = "USER_UPDATE_FAIL";

// CATEGORIES CONSTANT
export const CATEGORIES_CREATE_REQUEST = "CATEGORIES_CREATE_REQUEST";
export const CATEGORIES_CREATE_SUCCESS = "CATEGORIES_CREATE_SUCCESS";
export const CATEGORIES_CREATE_FAIL = "CATEGORIES_CREATE_FAIL";
export const ALL_CATEGORIES_VIEW_REQUEST = "ALL_CATEGORIES_VIEW_REQUEST";
export const ALL_CATEGORIES_VIEW_SUCCESS = "ALL_CATEGORIES_VIEW_SUCCESS";
export const ALL_CATEGORIES_VIEW_FAIL = "ALL_CATEGORIES_VIEW_FAIL";
export const CATEGORY_UPDATE_REQUEST = "CATEGORY_UPDATE_REQUEST";
export const CATEGORY_UPDATE_SUCCESS = "CATEGORY_UPDATE_SUCCESS";
export const CATEGORY_UPDATE_FAIL = "CATEGORY_UPDATE_FAIL";

// SUBCATEGORIES CONSTANT
export const SUBCATEGORIES_CREATE_REQUEST = "SUBCATEGORIES_CREATE_REQUEST";
export const SUBCATEGORIES_CREATE_SUCCESS = "SUBCATEGORIES_CREATE_SUCCESS";
export const SUBCATEGORIES_CREATE_FAIL = "SUBCATEGORIESITEM_CREATE_FAIL";
export const ALL_SUBCATEGORIES_VIEW_REQUEST = "ALL_SUBCATEGORIES_VIEW_REQUEST";
export const ALL_SUBCATEGORIES_VIEW_SUCCESS = "ALL_SUBCATEGORIES_VIEW_SUCCESS";
export const ALL_SUBCATEGORIES_VIEW_FAIL = "ALL_SUBCATEGORIES_VIEW_FAIL";
export const SUBCATEGORY_UPDATE_REQUEST = "SUBCATEGORY_UPDATE_REQUEST";
export const SUBCATEGORY_UPDATE_SUCCESS = "SUBCATEGORY_UPDATE_SUCCESS";
export const SUBCATEGORY_UPDATE_FAIL = "SUBCATEGORY_UPDATE_FAIL";
export const GROUP_SUBCATEGORIES_VIEW_REQUEST =
  "GROUP_SUBCATEGORIES_VIEW_REQUEST";
export const GROUP_SUBCATEGORIES_VIEW_SUCCESS =
  "GROUP_SUBCATEGORIES_VIEW_SUCCESS";
export const GROUP_SUBCATEGORIES_VIEW_FAIL = "GROUP_SUBCATEGORIES_VIEW_FAIL";

// ITEM CONSTANT
export const ITEM_CREATE_REQUEST = "ITEM_CREATE_REQUEST";
export const ITEM_CREATE_SUCCESS = "ITEM_CREATE_SUCCESS";
export const ITEM_CREATE_FAIL = "ITEM_CREATE_FAIL";
export const ALL_ITEM_VIEW_REQUEST = "ALL_ITEM_VIEW_REQUEST";
export const ALL_ITEM_VIEW_SUCCESS = "ALL_ITEM_VIEW_SUCCESS";
export const ALL_ITEM_VIEW_FAIL = "ALL_ITEM_VIEW_FAIL";
export const ITEM_UPDATE_REQUEST = "ITEM_UPDATE_REQUEST";
export const ITEM_UPDATE_SUCCESS = "ITEM_UPDATE_SUCCESS";
export const ITEM_UPDATE_FAIL = "ITEM_UPDATE_FAIL";
export const ITEMS_BY_ID_SUCCESS = "ITEMS_BY_ID_SUCCESS";

// ORDER CONSTANT
export const ORDER_CREATE_REQUEST = "ORDER_CREATE_REQUEST";
export const ORDER_CREATE_SUCCESS = "ORDER_CREATE_SUCCESS";
export const ORDER_CREATE_FAIL = "ORDER_CREATE_FAIL";
export const ALL_ORDER_VIEW_REQUEST = "ALL_ORDER_VIEW_REQUEST";
export const ALL_ORDER_VIEW_SUCCESS = "ALL_ORDER_VIEW_SUCCESS";
export const ALL_ORDER_VIEW_FAIL = "ALL_ORDER_VIEW_FAIL";
export const ORDER_BY_ID_SUCCESS = "ORDER_BY_ID_SUCCESS";
export const ORDER_UPDATE_REQUEST = "ORDER_UPDATE_REQUEST";
export const ORDER_UPDATE_SUCCESS = "ORDER_UPDATE_SUCCESS";
export const ORDER_UPDATE_FAIL = "ORDER_UPDATE_FAIL";
export const ADDRESS_DELIVER_SUCCESS = "ADDRESS_DELIVER_SUCCESS";

// STORE CONSTANT
export const STORE_CREATE_REQUEST = "STORE_CREATE_REQUEST";
export const STORE_CREATE_SUCCESS = "STORE_CREATE_SUCCESS";
export const STORE_CREATE_FAIL = "STORE_CREATE_FAIL";
export const ALL_STORE_VIEW_REQUEST = "ALL_STORE_VIEW_REQUEST";
export const ALL_STORE_VIEW_SUCCESS = "ALL_STORE_VIEW_SUCCESS";
export const ALL_STORE_VIEW_FAIL = "ALL_STORE_VIEW_FAIL";
export const STORE_BY_ID_SUCCESS = "STORE_BY_ID_SUCCESS";
export const STORE_UPDATE_REQUEST = "STORE_UPDATE_REQUEST";
export const STORE_UPDATE_SUCCESS = "STORE_UPDATE_SUCCESS";
export const STORE_UPDATE_FAIL = "STORE_UPDATE_FAIL";

// STORE CONSTANT
export const CITY_CREATE_REQUEST = "CITY_CREATE_REQUEST";
export const CITY_CREATE_SUCCESS = "CITY_CREATE_SUCCESS";
export const CITY_CREATE_FAIL = "CITY_CREATE_FAIL";
export const ALL_CITY_VIEW_REQUEST = "ALL_CITY_VIEW_REQUEST";
export const ALL_CITY_VIEW_SUCCESS = "ALL_CITY_VIEW_SUCCESS";
export const ALL_CITY_VIEW_FAIL = "ALL_CITY_VIEW_FAIL";
export const CITY_UPDATE_REQUEST = "CITY_UPDATE_REQUEST";
export const CITY_UPDATE_SUCCESS = "CITY_UPDATE_SUCCESS";
export const CITY_UPDATE_FAIL = "CITY_UPDATE_FAIL";
